<template>
  <sf-modal
    v-if="modalOpen"
    :scrollable-content="false"
    class="sf-border-box"
    size="s"
    @close="close"
  >
    <template #title>
      <span
        v-dompurify-html="
          I18n.t('reconciliation_text.copy_data.modal_title_html', {
            name: reconciliationTextName,
            period: currentPeriodName,
          })
        "
      ></span>
    </template>
    <template #body>
      <div v-if="isLoading" class="sf-level sf-level-center">
        <div class="sf-spinner"></div>
      </div>
      <div v-else class="sf-grid sf-grid-fluid">
        <div>
          <div class="sf-level sf-below-3 sf-pad-h-5 sf-pad-v-3">
            <div class="sf-level-item">
              {{
                I18n.t('reconciliation_text.copy_data.modal_roll_data_forward')
              }}
            </div>
          </div>
          <div class="sf-level sf-below-1 sf-pad-h-5">
            <div class="sf-level-item sf-font-medium">
              {{ I18n.t('reconciliation_text.copy_data.pick_period') }}
            </div>
          </div>
          <div class="sf-level sf-pad-h-5">
            <div class="sf-dropdown sf-level-item sf-full-width">
              <div
                class="sf-form-select-wrapper sf-full-width"
                data-toggle="dropdown"
              >
                <div class="sf-form-select sf-font-light">
                  <span v-if="selectedLedger">{{ selectedLedger.name }}</span
                  ><span v-else
                    ><i>{{
                      I18n.t('reconciliation_text.copy_data.select_period')
                    }}</i></span
                  >
                </div>
              </div>
              <div
                class="
                  sf-dropdown-menu sf-tab
                  tw-max-h-[400px] tw-overflow-y-auto
                "
              >
                <span v-for="ledger in ledgers" :key="ledger.id"
                  ><a
                    class="sf-a sf-block sf-tab-item"
                    @click="selectLedger(ledger)"
                    >{{ ledger.name }}</a
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #messages-bottom>
      <SfModalMessage v-if="existingData" variant="error">
        <span
          v-dompurify-html="
            I18n.t('reconciliation_text.copy_data.warning', {
              period: currentPeriodName,
            })
          "
        ></span>
      </SfModalMessage>
    </template>

    <template #footer>
      <div
        :class="{
          'sf-btn-danger': existingData,
          'sf-btn-primary': !existingData,
          'sf-btn-disabled': !selectedLedger,
        }"
        class="sf-btn"
        @click="copyLedger"
      >
        {{
          I18n.t('reconciliation_text.copy_data.yes_override', {
            period: currentPeriodName,
          })
        }}
      </div>
      <div class="sf-level sf-level-right">
        <a class="sf-btn" @click="close">{{ I18n.t('confirmation.cancel') }}</a>
      </div>
    </template>
  </sf-modal>
</template>

<script>
import api from '../api/index'
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'

export default {
  components: {
    SfModal,
    SfModalMessage,
  },

  data() {
    return {
      modalOpen: true,
      isLoading: false,
      selectedLedger: null,
      currentPeriodName: null,
      reconciliationTextName: null,
      existingData: false,
      ledgers: [],
      ledgerId: null,
      reconciliationTextId: null,
    }
  },

  methods: {
    openModal({
      ledgerId,
      currentPeriodName,
      reconciliationTextId,
      reconciliationTextName,
    }) {
      this.currentPeriodName = currentPeriodName
      this.reconciliationTextName = reconciliationTextName
      this.modalOpen = true
      this.isLoading = true
      this.ledgerId = ledgerId
      this.reconciliationTextId = reconciliationTextId

      api.getModalData({ ledgerId, reconciliationTextId }).then((data) => {
        this.ledgers = data.ledgers
        this.existingData = data.existing_data
        this.isLoading = false
      })
    },

    close() {
      this.modalOpen = false
    },

    selectLedger(id) {
      this.selectedLedger = id
    },
    copyLedger() {
      window.eventHub.$emit('confirmUnreviewTemplate', {
        callback: () => {
          this.doCopyLedger()
        },
      })
    },
    doCopyLedger() {
      api
        .copyLedger({
          fromLedger: this.selectedLedger.id,
          reconciliationTextId: this.reconciliationTextId,
          ledgerId: this.ledgerId,
        })
        .then(() => this.close())
    },
  },
}
</script>
